import gql from 'graphql-tag';

export const GET_STUDENT_INFO = gql`
  query (
    $programmeCodeFilter: ProgrammeCodeFilter!
    $nominationFilter: NominationFilter!
    $assessmentFilter: AssessmentFilter!
  ) {
    programmeChoiceMetadata {
      departments {
        value
        label
      }
    }

    programmeCode(input: $programmeCodeFilter) {
      programmeCode
    }

    nominations(filter: $nominationFilter) {
      application {
        applicationNo
        programmeChoice {
          studyMode
          department
        }
        programmeChoice {
          entryYear
        }
        merits {
          _id
        }
        publications {
          _id
        }
        applicant {
          name {
            givenName
            surname
            chineseName
          }
          identity {
            identityType
            identityDocumentType
            isLocal
          }
        }
        declaration {
          personalType
          confirmation
          informationAccuracy
          engagement
        }
      }
      admission {
        programme
        requirements {
          justification
          generalEntranceRequirements {
            justification
          }
        }
      }
      fundings {
        schema
        source
        status
        proofOfScheme {
          id
          link
          name
        }
        fundingPlan {
          accountCode
          period {
            from
            to
          }
        }
      }
      remarks
      declarations {
        content
        confirmed
        justification
      }
      supervisors {
        netId
        type
        title
        jobTitle
        givenName
        surname
        department
        institution
        email
        previousSuccessfulSupervision
        isDrcChair
        isDoRPgS
        confirmedAsCoSupervisor
        coSupervisorDeclarationRemark
      }
      admission {
        requirements {
          justification
        }
      }
    }

    publicationAssessment(filter: $assessmentFilter) {
      publicationReferenceId
      publicationType
    }
    meritAssessment(filter: $assessmentFilter) {
      meritReferenceId
      meritType
      researchLevel
    }
  }
`;

export const GET_STUDENT_FILES = gql`
  query ($id: ID!) {
    application(id: $id) {
      academicQualifications {
        certificates {
          id
          link
          name
        }
        transcripts {
          id
          link
          name
        }
      }
    }
  }
`;
